import React from 'react';
import Link from 'next/link';

export default function MarketingFooter() {
  return (
    <footer className="bg-[#060B14] border-t border-[#1E293B]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="lg:col-span-4">
            <a href="https://www.irongatesupply.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 mb-4">
              <img
                src="/assets/images/7a15e6d7-4494-4b56-acb6-b8320904c93b-1778298607010.png"
                alt="BridgeFlow™ MTE System"
                className="h-10 w-auto object-contain"
              />
              <img
                src="/assets/images/ISlogo_no_background-1778299302885.jpeg"
                alt="Iron Gate Supply"
                className="h-10 w-auto object-contain"
              />
            </a>
            <p className="text-[#64748B] text-sm leading-relaxed max-w-xs">
              Patented Mechanical Torque Equalization technology. Engineered for flange integrity, shutdown acceleration, and zero-leak performance.
            </p>
            <div className="mt-6 flex items-center gap-2">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-[#F97316]/10 border border-[#F97316]/20 text-[#F97316] text-xs font-semibold">
                <span className="w-1.5 h-1.5 rounded-full bg-[#F97316] animate-pulse"></span>
                ASME B16.5 Compatible
              </span>
            </div>
          </div>

          {/* Links */}
          <div className="lg:col-span-2">
            <h4 className="text-[#F1F5F9] text-sm font-semibold mb-4 uppercase tracking-wider">Product</h4>
            <ul className="space-y-3">
              {[
                { label: 'Overview', href: '/product' },
                { label: 'Three Versions', href: '/product#versions' },
                { label: 'Technical Specs', href: '/product#specs' },
                { label: 'How It Works', href: '/product#how-it-works' },
              ]?.map((l) => (
                <li key={l?.href}>
                  <Link href={l?.href} className="text-[#64748B] text-sm hover:text-[#F97316] transition-colors">{l?.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-[#F1F5F9] text-sm font-semibold mb-4 uppercase tracking-wider">Industries</h4>
            <ul className="space-y-3">
              {[
                { label: 'Pipeline & Gas', href: '/industries#pipeline' },
                { label: 'LNG Terminals', href: '/industries#lng' },
                { label: 'Offshore Platforms', href: '/industries#offshore' },
                { label: 'Refining & Petrochem', href: '/industries#refining' },
                { label: 'Hydrogen Infrastructure', href: '/industries#hydrogen' },
              ]?.map((l) => (
                <li key={l?.href}>
                  <Link href={l?.href} className="text-[#64748B] text-sm hover:text-[#F97316] transition-colors">{l?.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="text-[#F1F5F9] text-sm font-semibold mb-4 uppercase tracking-wider">Company</h4>
            <ul className="space-y-3">
              {[
                { label: 'Why BridgeFlow', href: '/why-bridgeflow' },
                { label: 'ROI Calculator', href: '/roi-calculator' },
                { label: 'Contact Us', href: '/contact' },
                { label: 'Request Demo', href: '/contact#demo' },
              ]?.map((l) => (
                <li key={l?.href}>
                  <Link href={l?.href} className="text-[#64748B] text-sm hover:text-[#F97316] transition-colors">{l?.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* CTA */}
          <div className="lg:col-span-2">
            <h4 className="text-[#F1F5F9] text-sm font-semibold mb-4 uppercase tracking-wider">Get Started</h4>
            <p className="text-[#64748B] text-sm mb-4 leading-relaxed">One hour of avoided downtime often pays for the entire system.</p>
            <Link
              href="/contact#demo"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-[#F97316] text-white text-sm font-semibold hover:bg-[#EA580C] transition-all duration-150 shadow-lg shadow-orange-500/20"
            >
              Request Demo
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M1 7h12M8 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#1E293B] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#475569] text-xs">© {new Date()?.getFullYear()} BridgeFlow™ MTE System. All rights reserved. Patented technology.</p>
          <p className="text-[#475569] text-xs">Engineered for flange integrity. Built for shutdown acceleration.</p>
        </div>
      </div>
    </footer>
  );
}
